// Only listings instructed on or after this date carry the investor-figure items.
//
// Without the gate, turning the items on adds them to 210 open roadblocks — 110 of which are
// already live on the portals, so the gate they exist to serve has already passed and the item
// can never be anything but noise. That is the `sign_erected` failure repeated: ~200 roadblocks
// given an item nothing resolved, breaching the 7-day SLA on contact with real data and never
// recovering (ADR 0009).
export const LISTING_INVESTOR_FIGURES_GO_LIVE = "2026-10-13";
